
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const BookingChart = () => {
    const options = {
        chart: {
            type: 'line',
            backgroundColor: 'transparent'
        },
        title: {
            text: null
        },
        credits: {
            enabled: false
        },
        xAxis: {
            categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            gridLineWidth: 1,
            gridLineColor: '#f0f0f0'
        },
        yAxis: {
            title: {
                text: 'Pemesanan'
            },
            gridLineColor: '#f0f0f0'
        },
        series: [{
            name: 'Minggu Ini',
            data: [12, 15, 18, 22, 25, 28, 24],
            color: '#DFFF00',
            lineWidth: 3
        }, {
            name: 'Minggu Lalu',
            data: [8, 12, 14, 18, 20, 24, 20],
            color: '#E07A5F',
            lineWidth: 2
        }],
        legend: {
            align: 'right',
            verticalAlign: 'top'
        }
    };

    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Tren Pemesanan</h3>
            <div id="booking-chart" style={{ height: '300px' }}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
        </div>
    );
};

export default BookingChart;
